/**
* Service Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Service Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'service-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.service-slider' ).length ) {
        $( '.service-slider__splide' ).each( function( index, element ) {
          const slider = new Splide( element, {
            type: 'slide',
            gap: '2rem',
            perPage: 3,
            perMove: 1,
            pagination: false,
            breakpoints: {
              1024: {
                perPage: 2,
              },
              768: {
                perPage: 1,
              },
            },
          } );
          const progressBar = slider.root.querySelector( '.service-slider__progress-bar' );
          // Updates the bar width whenever the carousel moves:
          slider.on( 'mounted move', function() {
            const end = slider.Components.Controller.getEnd() + 1;
            const rate = Math.min( ( slider.index + 1 ) / end, 1 );
            progressBar.style.width = String( 100 * rate ) + '%';
          } );
          slider.mount();
          const sliderId = $( this ).attr( 'id' );
          $( '.slider-tab-button[data-toggle-target="#' + sliderId + '"]' ).on( 'click', function() {
            slider.refresh();
          } );
        } );
      }
      mobileDropdown();
      $( window ).on( 'resize', function() {
        mobileDropdown();
      } );
      function mobileDropdown() {
        if ( window.innerWidth < 768 ) {
          let open = false;
          $( '.mobile-dropdown' ).on( 'click', function() {
            if ( open === false ) {
              $( this ).addClass( 'active' );
              open = true;
            } else if ( open === true ) {
              $( '.mobile-dropdown' ).removeClass( 'active' );
              open = false;
            }
          } );
        }
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'service-slider', COMPONENT );
} )( app );
